// Central registry of data-testid values for the Dubinko app.

export const NAV = {
  brand: 'nav-brand',
  linkHome: 'nav-link-home',
  linkServices: 'nav-link-services',
  linkBooking: 'nav-link-booking',
  linkAbout: 'nav-link-about',
  linkContact: 'nav-link-contact',
  linkLogin: 'nav-link-login',
  linkRegister: 'nav-link-register',
  linkDashboard: 'nav-link-dashboard',
  linkAdmin: 'nav-link-admin',
  linkReviews: 'nav-link-reviews',
  linkAreas: 'nav-link-areas',
  linkBlog: 'nav-link-blog',
  logoutBtn: 'nav-logout-btn',
  mobileToggle: 'nav-mobile-toggle',
};

export const HOME = {
  hero: 'hero-section',
  heroTitle: 'hero-title',
  heroSubtitle: 'hero-subtitle',
  heroBookBtn: 'hero-book-btn',
  heroQuoteBtn: 'hero-quote-btn',
  heroServicesBtn: 'hero-services-btn',
  servicesGrid: 'services-grid',
  serviceCardResidential: 'service-card-residential',
  serviceCardCommercial: 'service-card-commercial',
  serviceCardCarpet: 'service-card-carpet',
  beforeAfter: 'before-after-slider',
  testimonials: 'testimonials-section',
  howItWorks: 'how-it-works',
  ctaBottom: 'cta-bottom',
  emergentLink: 'emergent-link',
};

export const MASCOT = {
  bubble: 'mascot-bubble',
  open: 'mascot-open',
  close: 'mascot-close',
  input: 'mascot-input',
  send: 'mascot-send',
  message: 'mascot-message',
  heroCharacter: 'dubi-hero-character',
  heroBubbleCta: 'dubi-hero-cta',
  quickQuote: 'mascot-quick-quote',
  quickBook: 'mascot-quick-book',
  quickServices: 'mascot-quick-services',
  quickOperator: 'mascot-quick-operator',
  leadForm: 'mascot-lead-form',
  leadName: 'mascot-lead-name',
  leadPhone: 'mascot-lead-phone',
  leadEmail: 'mascot-lead-email',
  leadAddress: 'mascot-lead-address',
  leadMessage: 'mascot-lead-message',
  leadSubmit: 'mascot-lead-submit',
  leadSuccess: 'mascot-lead-success',
};

export const AUTH = {
  loginForm: 'login-form',
  loginEmail: 'login-email',
  loginPassword: 'login-password',
  loginSubmit: 'login-submit',
  registerForm: 'register-form',
  registerName: 'register-name',
  registerEmail: 'register-email',
  registerPhone: 'register-phone',
  registerPassword: 'register-password',
  registerSubmit: 'register-submit',
  errorMessage: 'auth-error-message',
};

export const BOOKING = {
  wizard: 'booking-wizard',
  step1: 'booking-step-service',
  step2: 'booking-step-details',
  step3: 'booking-step-datetime',
  step4: 'booking-step-contact',
  step5: 'booking-step-confirm',
  serviceResidential: 'booking-service-residential',
  serviceCommercial: 'booking-service-commercial',
  serviceCarpet: 'booking-service-carpet',
  rooms: 'booking-rooms',
  size: 'booking-size',
  date: 'booking-date',
  time: 'booking-time',
  address: 'booking-address',
  notes: 'booking-notes',
  guestName: 'booking-guest-name',
  guestEmail: 'booking-guest-email',
  guestPhone: 'booking-guest-phone',
  next: 'booking-next',
  back: 'booking-back',
  submit: 'booking-submit',
  success: 'booking-success',
};

export const QUOTE = {
  form: 'quote-form',
  name: 'quote-name',
  email: 'quote-email',
  phone: 'quote-phone',
  service: 'quote-service',
  message: 'quote-message',
  submit: 'quote-submit',
  success: 'quote-success',
};

export const CONTACT = {
  form: 'contact-form',
  name: 'contact-name',
  email: 'contact-email',
  message: 'contact-message',
  submit: 'contact-submit',
  success: 'contact-success',
};

export const DASHBOARD = {
  root: 'customer-dashboard',
  tabUpcoming: 'cust-tab-upcoming',
  tabHistory: 'cust-tab-history',
  tabReviews: 'cust-tab-reviews',
  tabQuestions: 'cust-tab-questions',
  bookingsList: 'dashboard-bookings-list',
  bookingItem: 'dashboard-booking-item',
  rebookBtn: 'dashboard-rebook-btn',
  cancelBtn: 'dashboard-cancel-btn',
  rescheduleBtn: 'dashboard-reschedule-btn',
  rescheduleDate: 'dashboard-reschedule-date',
  rescheduleTime: 'dashboard-reschedule-time',
  rescheduleConfirm: 'dashboard-reschedule-confirm',
  reviewOpenBtn: 'dashboard-review-open',
  reviewRating: 'dashboard-review-rating',
  reviewText: 'dashboard-review-text',
  reviewSubmit: 'dashboard-review-submit',
  questionSubject: 'dashboard-question-subject',
  questionMessage: 'dashboard-question-message',
  questionSubmit: 'dashboard-question-submit',
};

export const ADMIN = {
  root: 'admin-dashboard',
  tabBookings: 'admin-tab-bookings',
  tabQuotes: 'admin-tab-quotes',
  tabMessages: 'admin-tab-messages',
  tabContent: 'admin-tab-content',
  tabCustomers: 'admin-tab-customers',
  tabReviews: 'admin-tab-reviews',
  tabAreas: 'admin-tab-areas',
  tabCustomerMessages: 'admin-tab-customer-messages',
  tabSEO: 'admin-tab-seo',
  tabAssistant: 'admin-tab-assistant',
  tabStats: 'admin-tab-stats',
  tabBlog: 'admin-tab-blog',
  statsRange: 'admin-stats-range',
  // Assistant (chat + leads)
  operatorToggle: 'admin-operator-toggle',
  operatorAway: 'admin-operator-away',
  operatorOnlineMsg: 'admin-operator-online',
  operatorSave: 'admin-operator-save',
  leadsList: 'admin-leads-list',
  leadRow: 'admin-lead-row',
  leadStatus: 'admin-lead-status',
  bookingsTable: 'admin-bookings-table',
  bookingRow: 'admin-booking-row',
  statusSelect: 'admin-status-select',
  paymentSelect: 'admin-payment-select',
  paidInput: 'admin-paid-input',
  priceInput: 'admin-price-input',
  notesInput: 'admin-notes-input',
  saveBtn: 'admin-save-btn',
  reminderBtn: 'admin-reminder-btn',
  followUpBtn: 'admin-followup-btn',
  contentForm: 'admin-content-form',
  contentHeroTitle: 'admin-hero-title',
  contentHeroSubtitle: 'admin-hero-subtitle',
  contentPhone: 'admin-phone',
  contentEmail: 'admin-email',
  contentInstagram: 'admin-instagram',
  contentSave: 'admin-content-save',
  // SEO
  seoGaId: 'admin-ga-id',
  seoGsc: 'admin-gsc-verification',
  seoGbp: 'admin-gbp-url',
  seoStreet: 'admin-business-street',
  seoPostal: 'admin-business-postal',
  seoLat: 'admin-business-lat',
  seoLng: 'admin-business-lng',
  seoHours: 'admin-business-hours',
  seoSave: 'admin-seo-save',
  // Customers
  customersList: 'admin-customers-list',
  customerRow: 'admin-customer-row',
  customerOpen: 'admin-customer-open',
  customerNotes: 'admin-customer-notes',
  customerNotesSave: 'admin-customer-notes-save',
  // Reviews
  reviewsList: 'admin-reviews-list',
  reviewRow: 'admin-review-row',
  reviewApprove: 'admin-review-approve',
  reviewHide: 'admin-review-hide',
  // Areas
  areasList: 'admin-areas-list',
  areaRow: 'admin-area-row',
  areaName: 'admin-area-name',
  areaDescription: 'admin-area-description',
  areaCreate: 'admin-area-create',
  areaDelete: 'admin-area-delete',
  // Customer messages
  cMessagesList: 'admin-cmessages-list',
  cMessageReply: 'admin-cmessage-reply',
  cMessageReplyText: 'admin-cmessage-reply-text',
  cMessageReplySend: 'admin-cmessage-reply-send',
};

export const REVIEWS = {
  page: 'reviews-page',
  card: 'review-card',
};

export const AREAS = {
  index: 'areas-index',
  card: 'area-card',
  page: 'area-page',
};
